import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps, styled } from "@mui/material";

const StyledSkeleton = styled(MuiSkeleton)(() => ({
  // Additional styles
}));

interface SkeletonProps extends MuiSkeletonProps {}

export const Skeleton: React.FC<SkeletonProps> = ({ ...props }) => {
  return <StyledSkeleton {...props} />;
};

export default Skeleton;
